export default "__VITE_ASSET__DdK3fqAl__"